module.exports = __webpack_public_path__ + "img/photoshop.8ca8f89d.svg";